import styled from 'styled-components';

const StyledButton = styled.button`
	border: none;
	background: #1B9AAA;
	color: #fff;
	padding: 15px 20px;
	border-radius: 4px;
	margin: 20px;
	font-size: inherit;
`;

export default StyledButton;



// WEBPACK FOOTER //
// ./src/components/Button/Button.styles.js